import _styled from "styled-components";
import { type Mode, type Theme } from "~/features/ui/get-theme-style";
import { type MediaCardsCardViewProps } from "~/features/blocks/inventory/media-cards/media-cards-card";
import { takeFirst } from "~/features/app/utils";
import { AdaptiveSection } from "~/features/ui/adaptive-section";
type SectionDataAttrs = Record<`data-${string}`, string | undefined>;
export type MediaCardsBlockViewProps<TCard = MediaCardsCardViewProps> = {
  anchor?: Array<{
    id?: string | null;
    name?: string | null;
  }> | {
    id?: string | null;
    name?: string | null;
  } | null;
  cards?: TCard[] | null;
  getCardKey?: (card: TCard, index: number) => React.Key;
  hasTopDivider?: boolean | null;
  mode?: string | null;
  renderCard: (card: TCard, index: number, ratio: "3/2" | "16/9") => React.ReactNode;
  sectionProps?: React.ComponentPropsWithoutRef<"section"> & SectionDataAttrs;
  theme?: string | null;
};
export function MediaCardsBlockView<TCard = MediaCardsCardViewProps>({
  anchor,
  cards = [],
  getCardKey,
  hasTopDivider = true,
  mode = "light",
  renderCard,
  sectionProps,
  theme = "white"
}: MediaCardsBlockViewProps<TCard>) {
  const entries = cards ?? [];
  // v3 media cards render without vertical separators on the section surface.
  // `bg-primary` is mode-aware (white in light mode, near-black in dark) and must
  // match AdaptiveSection's `whiteSurface`; a static white here left dark-mode
  // cards with white text on a white card.
  const surface = {
    "backgroundColor": "var(--bg-primary)"
  };
  const ratio = entries.length === 3 ? "3/2" : "16/9";
  return <AdaptiveSection {...sectionProps} id={takeFirst(anchor)?.id || undefined} data-anchor-name={takeFirst(anchor)?.name || undefined} mode={mode as Mode} theme={theme as Theme} mobileLayout="grid" hasTopDivider={hasTopDivider ?? true} whiteSurface hideDividers>
      {entries.map((card, idx) => <_StyledDiv key={getCardKey?.(card, idx) || idx} $_css={[{
      "position": "relative",
      "zIndex": "10",
      "height": "100%"
    }, surface]}>
          {renderCard(card, idx, ratio)}
        </_StyledDiv>)}
    </AdaptiveSection>;
}
var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "media-cards___StyledDiv",
  componentId: "sc-15y2pyq-0"
})(["", ""], p => p.$_css);